import Cookies from 'universal-cookie';  // Assuming you are using 'universal-cookie' for token management

const cookies = new Cookies();

export const getUserToken = () => {
  return cookies.get('AccessToken');  // Retrieves the token from cookies
};

export const setUserToken = (token) => {
  cookies.set('AccessToken', token, { path: '/', maxAge: 86400 });  // Sets the token with a 1-day expiration
};

export const isLogin = () => {
  return !!cookies.get('AccessToken');  // Returns true if token exists
};

export const clearUserToken = () => {
  cookies.remove('AccessToken', { path: '/' });
  sessionStorage.removeItem('access_token');  // Clear session storage (optional)
  window.localStorage.clear();  // Clear local storage (optional)
  window.location.href = "/";   // Redirect to home or login page
};
